import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

export const downloadInteractionHistoryDocs = (reqBody: any, abortController: any) => {
  const config = sitConfig(RootStore.session.getTokens, abortController)
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.downloadInteractionHistoryDocs),
    method: 'POST',
    responseType: 'arraybuffer',
    config,
    headers: getHeaders(),
    body: reqBody,
  }

  return executeRequest(request)
    .then((response) => {
      if (isSuccessResponse(response)) {
        return response
      }
    })
    .catch((error) => {
      throw error
    })
}
